import DropDown from 'react-dropdown';
import 'react-dropdown/style.css';
import './DropDown.module.scss';

export * from 'react-dropdown';
export default DropDown;
